import { Helmet } from "react-helmet";
import backgroundImg from "../images/Section-1/background.png";
import sectionOneImg from "../images/Section-1/section-one-img.png";
import sectionOneImgTwo from "../images/Section-1/section-one-img-two.png";

export default function SectionOne({ openModal }: any) {
  return (
    <div className="w-full relative overflow-hidden pt-4 font-poppins">
      <Helmet>
        <title>DUMOSH - Double Your Patient Walk-ins</title>
        <meta
          name="description"
          content="DUMOSH helps you focus on treating patients, not marketing headaches. Double your patient walk-ins today!"
        />
        <meta
          property="og:title"
          content="DUMOSH - Double Your Patient Walk-ins"
        />
        <meta
          property="og:description"
          content="DUMOSH helps you focus on treating patients, not marketing headaches."
        />
        <meta property="og:image" content={sectionOneImg} />
        <meta property="og:type" content="website" />
        <link rel="preload" as="image" href={backgroundImg} />
        <link rel="preload" as="image" href={sectionOneImg} />
      </Helmet>

      {/* Background */}
      <div
        className="absolute inset-0 bg-cover h-[70%] bg-no-repeat bg-center z-0"
        style={{ backgroundImage: `url(${backgroundImg})` }}
      ></div>

      {/* Logo */}
      <p className="relative md:text-start text-center md:top-4 md:pl-14 pl-0 px-2  md:left-6 sm:left-0 lg:left-0 text-white text-2xl lg:text-4xl font-anton">
        DUMOSH<span className="text-[#FF3E3E]">.</span>
      </p>

      {/* Main Content */}
      <div className="relative z-10 max-w-7xl mx-auto md:px-10 px-2 md:py-10 py-4 ">
        {/* Top Section */}
        <div className=" flex md:flex-row flex-col-reverse  justify-around items-center p-8 rounded-xl text-white">
          {/* Left Text Section */}
          <div className="md:space-y-2 space-y-1">
            <p className="text-2xl md:text-4xl lg:text-6xl md:text-start text-center font-light">Revolutionize Your</p>
            <h1 className="text-2xl md:text-4xl lg:text-6xl md:text-start text-center font-bold leading-tight">Patient </h1>
            <h1 className="text-2xl md:text-4xl lg:text-6xl md:text-start text-center font-bold  leading-tight"> Acquisition</h1>

            <p className="text-xl md:text-4xl lg:text-6xl md:text-start text-center font-light">
              With <span className=" font-anton">DUMOSH’s</span>
            </p>
            <p className="text-[10px] md:text-xl  md:text-start text-center lg:text-2xl">
              End-to-End Marketing &
            </p>
            <p className="text-[10px] md:text-xl  md:text-start text-center lg:text-2xl">
              Business Accelerator Solutions
            </p>

            {/* Button (Positioned Over Image in mobile view) */}
            <div className="block md:hidden">
              <button
                onClick={openModal}
                className="mt-6 bg-white text-[#3E88FF] font-bold px-6 py-1 rounded-lg text-sm hover:scale-105 transition-transform"
              >
                Know More
              </button>
            </div>
          </div>

          {/* Right Image Section */}
          <div className="flex flex-col justify-center gap-4 items-center ">
            <img
              src={sectionOneImg}
              alt="illustration"
              className="w-[180px] md:w-[250px] lg:w-[350px] object-contain"
            />
            <div className="hidden md:block">
              <button
                onClick={openModal}
                className="bg-white text-[#3E88FF] font-bold px-8 py-1 rounded-lg text-lg hover:scale-105 transition-transform"
              >
                Know More
              </button>
            </div>
          </div>
        </div>

        {/* Lower Section */}
        <div className="bg-[#DFF5F7] shadow-xl lg:mx-20 md:mx-8 mx-4 p-4 md:p-6 rounded-3xl flex md:flex-row gap-4 flex-col items-center shadow-sm">
          {/* Left Image */}
          <div className="">
            <img
              src={sectionOneImgTwo}
              alt="illustration"
              className="w-[90%] object-contain"
            />
          </div>

          {/* Right Text Content */}
          <div className=" lg:space-y-3 space-y-1 text-[#58595B]">
            <h3 className="text-[14px] md:text-[14px] lg:text-xl text-left  font-semibold">
              Combine Cutting-Edge Digital Marketing with Expert Tele-Calling for Guaranteed Growth
            </h3>
            <p className="text-[12px] md:text-[8px] lg:text-sm text-left leading-relaxed">
              In today&apos;s competitive healthcare industry, attracting and retaining patients requires more than just a strong online presence. It demands a <b>personalized, human touch</b> that builds trust and drives action. At Dumosh, we&apos;ve mastered the art of blending <b>exceptional digital marketing</b> with <b>expert tele-calling services</b> to deliver unparalleled patient acquisition results.
            </p>
            <p className="text-[12px] md:text-[8px] lg:text-sm text-left leading-relaxed">
              Our unique approach ensures that every lead is nurtured, every opportunity is maximized, and every patient feels valued. Whether you&apos;re a small clinic or a large hospital, Dumosh&apos;s comprehensive service stack is designed to help you achieve <b>assured patient intake growth</b> and long-term success.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
